module.exports = __webpack_public_path__ + "img/img21.e50c844f.jpg";